import { Component, OnInit, Input } from '@angular/core';
import { TournamentsService } from '@app/services/tournaments/tournaments.service';
import { Fixture, TournamentTeam, Matchset, Roundset } from '@app/_models/tournament.model';
import * as moment from 'moment';
import { FacilityService } from '@app/services/facilities.service';
import { Field } from '@app/_models/facilities';
import { SessionService } from '@app/services/session.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { TournamentFixtureMatchResultComponent } from './tournament-fixture-match-result/tournament-fixture-match-result.component';
@Component({
  selector: 'tournament-fixture',
  templateUrl: './tournament-fixture.component.html',
  styleUrls: ['./tournament-fixture.component.scss'],
})
export class TournamentFixtureComponent implements OnInit {
  constructor(
    private _tournamentService: TournamentsService,
    private _facilityService: FacilityService,
    private _sessionService: SessionService,
    private _dialog: MatDialog,
    private _snackbar: MatSnackBar
  ) { }
  @Input() tournamentId: number;
  fixture: Fixture = {
    round_set: [],
  };
  fields: Field[] = [];
  tournamentTeams: TournamentTeam[] = [];
  ngOnInit() {
    const facilityId = this._sessionService.currentFacility.id;
    this._facilityService.getFields(facilityId).then(fields => {
      this.fields = fields;
    });
    this.getFixture();
    this._tournamentService.getTournamentTeams().subscribe(teams => {
      this.tournamentTeams = teams;
    });
  }

  getFixture() {
    this._tournamentService.getTournamentFixture(this.tournamentId).subscribe((fixtures) => {
      if (fixtures.length) {
        this.assembleFixture(fixtures[0]).then((fixture) => {
          this.fixture = fixture;
        });
      }
    });
  }

  createFixture() {
    this._tournamentService.createTournamentFixture(this.tournamentId).subscribe(fixture => {
      this.assembleFixture(fixture).then((fixture) => {
        this.fixture = fixture;
      });
    }, (err) => this._snackbar.open("No hay suficientes equipos confirmados para generar el fixture", "", { duration: 3000 }));
  }

  async assembleFixture(fixture: Fixture) {
    for (const round of fixture.round_set) {
      const matches = await this._tournamentService.getTournamentMatchesByRoundId(this.tournamentId, fixture.id, round.id).toPromise();
      round.match_set = matches;
    }
    return fixture;
  }

  openMatchResultModal(match: Matchset, round: Roundset) {
    const matchScore = this._dialog.open(TournamentFixtureMatchResultComponent, {
      width: '800px',
      data: {
        fixtureId: this.fixture.id,
        tournamentId: this.tournamentId,
        roundId: round.id,
        id: match.id,
        fieldName: this.getMatchField(match.field),
        time: this.getMatchTime(match.datetime),
        teamA: { name: this.getTeamProperty(match.team_a, 'name'), image: this.getTeamProperty(match.team_a, 'photo') },
        teamB: { name: this.getTeamProperty(match.team_b, 'name'), image: this.getTeamProperty(match.team_b, 'photo') }
      }
    });

    const closeDialogEvent = matchScore.componentInstance.closeDialogEvent.subscribe(() => {
      matchScore.close();
      this.getFixture();
    });

    matchScore.afterClosed().subscribe(() => closeDialogEvent.unsubscribe());
  }


  getMatchTime(datetime: string) {
    if (datetime) {
      return moment(datetime, moment.ISO_8601).format('HH:mm');
    }
    return "";
  }

  getMatchField(fieldId: number) {
    if (fieldId) {
      const field = this.fields.find(field => field.id === fieldId);
      return field.name;
    }
    return "Fecha libre";
  }

  getTeamProperty(teamId, property) {
    if (teamId) {
      const team = this.tournamentTeams.find(team => team.id === teamId);
      return team[property];
    }
    if (!teamId && property === 'photo') {
      return '';
    }
    return ' - ';
  }
}
